import React, {  useState, useEffect } from "react";
import axios from "axios";
import { authHeader } from "../../../../../helpers";
import dateFormat from "dateformat";

const BookingFilesList = ({ bookingId }) => {
  const [files, setFiles] = useState([]);

  // ✅ GET FILE LIST
  const fetchFiles = async () => {
    try {
      const res = await axios.get(
        `${process.env.REACT_APP_APIURL}reps/booking/booking-files/${bookingId}`,
        {
          headers: authHeader()
        }
      );
      setFiles(res.data.files || []);
    } catch (err) {
      console.error("Fetch error:", err);
    }
  };

  useEffect(() => {
    if (bookingId) fetchFiles();
  }, [bookingId]);


  

  return (
    <div className="d-card my-4">
      <div className="d-flex justify-content-between align-items-center mb-3">
          <h4 className="mb-0">Documents</h4>
     </div>
        

      {/* File List */}
      {files.map((file, i) => {
        const fileUrl = `${process.env.REACT_APP_APIURL}assets/uploads/kitDocuments/bookingFiles/${file.file_path}`;

        //const isImage = /\.(jpeg|jpg|png|gif|webp)$/i.test(file.file_path);

        return (
          <div
            key={file._id || i}
            className="mt-2"
            style={{
              border: "1px solid #ccc",
              padding: "10px",
              width: "100%",
              borderRadius: "6px"
            }}
          >
            {/* Preview */}
            <h4  className="mb-1">
               {file.file_name}
            </h4>
            <small>{dateFormat(file.createdAt, "dd-mm-yyyy HH:MM")} by {file.created_by?.first_name} {file.created_by?.last_name}</small>

            {/* Actions */}
            <div className="d-flex justify-content-end gap-2">
              <a
                href={fileUrl}
                target="_blank"
                rel="noopener noreferrer"
                className="btn btn-secondary btn-sm"
                style={{minWidth:"50px"}}
              >
                <i className="fa fa-download"></i>
              </a>

             
            </div>
          </div>
        );
      })}
    </div>
  );
};

export default BookingFilesList;